import React, {useEffect, useState} from 'react';
import styles from "./CreateProduct.module.css";
import Accordion from "../../components/Accordion/Accordion";
import Checkbox from "../../components/Checkbox";
import TextInput from "../../components/TextInput";
import ProductController from "../../controllers/ProductController";
import { useTranslation } from 'react-i18next';

const CreateProductVBM = ({isNew, p, errors, onPropertyChange, onError}) => {
    const { t } = useTranslation("createProductVBM");

    const productController = new ProductController();

    useEffect(()=>{
        if(!p.allowVBM){
            onPropertyChange({vbmDrugName: productController.getDefaultName(p)})
        }
    }, [p])

    return (
        <Accordion title={t("tab")}>
            <div className={styles.CreateProduct__productCategory_row}>
                <div className={styles.CreateProduct__productCategory_col}>
                    <Checkbox
                        labelName={t("doNotDispenseLabel")}
                        isOn={ p?.vbmDoNotDispense }
                        onCheck={isOn => onPropertyChange({vbmDoNotDispense: isOn})}
                    />
                </div>
                <div className={styles.CreateProduct__productCategory_col}>
                    <Checkbox
                        labelName={t("bcoOnlyLabel")}
                        isOn={ p?.vbmBCOOnly }
                        onCheck={isOn => onPropertyChange({vbmBCOOnly: isOn})}
                    />
                </div>
            </div>
            <br/>
            <div className={styles.CreateProduct__productCategory_row}>
                <div className={styles.CreateProduct__productCategory_col}>
                    <TextInput
                        type={'text'}
                        labelName={t("drugNameLabel")}
                        isEnabled={true}
                        value={p?.vbmDrugName || productController.getDefaultName(p)}
                        validationText={''}
                        focus={false}
                        onChange={val => {
                            onPropertyChange({vbmDrugName: val})
                        }}
                    />
                </div>
            </div>
        </Accordion>
    )
}

export default CreateProductVBM;
